<app-solutions-header-banner></app-solutions-header-banner>

<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center mt-20">
  <h2 class="font-bold text-3xl website-heading">Banking Financial Services and Insurance</h2>
  <span class="font-light text-2xl website-light-heading">Connected Platforms for Delivering Innovative Financial
    Services and Great Customer Experience</span>

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">Whether it is non-banking financial institutions (NBFCs)
    specializing in vehicle loans and insurers providing motor insurance, both can effectively engage customers, foster
    loyalty, and derive actionable insights using data-driven strategies. With more than a decade long experience in
    working and understanding this market, we have delivered value to some of the largest organizations in the Banking,
    NBFC and insurance industry players with our apps, cloud and hardware solutions.</span>

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">Organizations can work with their customers to promote
    better driving habits, better vehicle maintenance and transfer some of the cost savings to customers. We've helped
    these industry leaders in engaging with their vehicle customers, with their aftermarket or new vehicles, delivering
    tailored value through our offerings.</span>

  <div class="flex flex-col mt-10 gap-10  md:mt-20 md:gap-20 items-center justify-center">
    <img [src]="Images.SOLUTION_BFSI_BANNER" alt="Varroc Connect BFSI (Banking, Financial Services & Insurance) Solutions" class="w-1/2">
  </div>

</div>